
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/wachtwoord-vergeten",
      function () {
        return require("private-next-pages/auth/wachtwoord-vergeten.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/wachtwoord-vergeten"])
      });
    }
  